import React from 'react';

const AppContext = React.createContext(null);

/**
 * Hook to access shared app state from extracted page components.
 * Must be used within a component wrapped by AppContext.Provider in VaultApp.
 */
export function useAppContext() {
  const ctx = React.useContext(AppContext);
  if (!ctx) throw new Error('useAppContext must be used within AppContext.Provider');
  return ctx;
}

export default AppContext;
